export * from "./DynamicScriptLoad";
//# sourceMappingURL=index.js.map